import script from "./submit6.vue?vue&type=script&setup=true&lang=js"
export * from "./submit6.vue?vue&type=script&setup=true&lang=js"

import "./submit6.vue?vue&type=style&index=0&id=a661a5b0&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a661a5b0"]])

export default __exports__